import styled from 'styled-components/macro'

const MarketOptionsWrapper = styled('div')`
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
`

export default MarketOptionsWrapper
